import React, { useState, useCallback, memo } from 'react';
import { Button, Spinner, Table } from 'react-bootstrap';
import Icon from '../Icons';
import DocumentRow from './DocumentRow';

const DocumentsTable = memo(
  ({
    documents,
    handleButtonClick,
    permitedActions,
    handleLoadMoreDocuments,
    nextPage,
    canMoveFile,
    directoryNodes,
    createSubMenus,
    folderId,
    handleMoveDocument
  }) => {
    const [loadingFolder, setLoadingFolder] = useState(false);

    const handleLoadMore = useCallback(() => {
      setLoadingFolder(true);
      handleLoadMoreDocuments(folderId, nextPage, setLoadingFolder);
    }, [handleLoadMoreDocuments, folderId, nextPage]);

    const shouldShowLoadMore = nextPage;

    return (
      <>
        <Table
          className="custom-data-table custom-documents__table mb-0"
          bordered
          size="sm"
          style={{ fontWeight: 400 }}
        >
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              <th className="text-center align-middle" style={{ width: '40%' }}>
                Documento
              </th>
              <th className="text-center align-middle">Fecha Emisión</th>
              <th className="text-center align-middle">Estado</th>
              <th className="text-center align-middle">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {documents.length === 0 && (
              <tr>
                <td colSpan={4} className="text-center">
                  No hay documentos
                </td>
              </tr>
            )}
            {documents?.length > 0 &&
              documents.map(item => (
                <DocumentRow
                  key={item.id}
                  item={item}
                  handleButtonClick={handleButtonClick}
                  parentId={folderId}
                  permitedActions={permitedActions}
                  canMoveFile={canMoveFile}
                  directoryNodes={directoryNodes}
                  createSubMenus={createSubMenus}
                  handleMoveDocument={handleMoveDocument}
                />
              ))}
          </tbody>
        </Table>
        {shouldShowLoadMore &&
          (loadingFolder ? (
            <div className="text-center mt-2 mb-2">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="d-flex justify-content-end mt-2" style={{ width: '100%' }}>
              <div className="" style={{ paddingRight: '20px' }}>
                <Button className="mb-1 load_more__btn" variant="primary" size="sm" onClick={handleLoadMore}>
                  Más info
                  <Icon icon="plus" width="10px" height="10px" className="ml-2" />
                </Button>
              </div>
            </div>
          ))}
      </>
    );
  }
);

export default DocumentsTable;
